import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { Link, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import config from '../config/config'
import { LOGIN_PATH } from '../config/routes'
import NavigationBar from '../components/NavigationBar'
import Footer from '../components/Footer/Footer'
import PageHeroTitle from '../components/PageHeroTitle'

const RegisterValidation = () => {
  const [confirmationStatus, setConfirmationStatus] = useState(null)
  const { t } = useTranslation()
  const { token } = useParams()

  useEffect(() => {
    const confirmRegistration = async () => {
      try {
        // Check if token is given
        if (!token) {
          setConfirmationStatus('error')
          return
        }

        const response = await axios.get(
          `${config.apiUrl}user/confirmation-registration/${token}`,
        )
        if (response.status === 200) {
          setConfirmationStatus('success')
        } else if (response.status !== 204) {
          setConfirmationStatus('error')
        }
      } catch (error) {
        setConfirmationStatus('error')
      }
    }

    confirmRegistration()
  }, [token])

  let message
  if (confirmationStatus === 'success') {
    message = t('REGISTER_ACTIVATING_SUCCESS')
  } else if (confirmationStatus === 'error') {
    message = t('REGISTER_ERROR_ACTIVATING_ACCOUNT')
  } else {
    message = t('REGISTER_ACTIVATING_IN_PROGRESS')
  }

  return (
    <div>
      <NavigationBar />

      {/* Title */}
      <PageHeroTitle
        title={t('REGISTER_VALIDATION_TITLE')}
        description=""
      />

      <div className="p-3" style={{ marginBottom: '50px' }}>
        <p>{message}</p>

        <Link to={LOGIN_PATH} className="btn btn-primary m-2">
          {t('LOGIN_LOGIN')}
        </Link>
      </div>
      <Footer />
    </div>
  )
}

export default RegisterValidation
